import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import { errorMonitoringService } from './services/errorMonitoringService';

// Initialize Sentry error monitoring
errorMonitoringService?.initialize();

const container = document.getElementById("root");
const root = createRoot(container);

// Log to verify app is mounting
console.log('🚀 Recrutees app initializing...');

root.render(<App />);

console.log('✅ Recrutees app rendered successfully');